module.exports = __webpack_public_path__ + "media/images/flags/4x3/dji-71cf15bfdae4875204d6ca4c6a102f10.svg";